var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronUpGray400(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1623_1218",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 8,
    width: 14,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7 8.3L18.7 14.3C18.9 14.5 19 14.7 19 15C19 15.3 18.9 15.5 18.7 15.7C18.3 16.1 17.7 16.1 17.3 15.7L12 10.4L6.7 15.7C6.3 16.1 5.7 16.1 5.3 15.7C4.9 15.3 4.9 14.7 5.3 14.3L11.3 8.3C11.7 7.9 12.3 7.9 12.7 8.3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1623_1218)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0 24) rotate(-90)",
    fill: "#888888"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpGray400);
export default __webpack_public_path__ + "static/media/chevron_up_gray400.07e0818001e1bc8167b1e256db4e6349.svg";
export { ForwardRef as ReactComponent };